export enum TipMode {
    Depth = 'DEPTH',
    Curves = 'CURVES',
    Coords = 'COORDS',
}

interface Depth {
    relative: number,
    absolute?: number,
}

// TODO: описать типы для unknown
export interface RunnerState {
    depth: Depth,
    runnerValue: Depth | null,
    runnerTooltipMode: unknown,
    runnerValues: unknown,

    isActiveRunner: boolean,
    viewMode: boolean,
    tipMode: TipMode,
    tooltipInfoData: null | unknown,
}

export interface RunnerDispatch {
    setDepth: (value: RunnerState['depth']) => void;
    setRunnerValue: (value: RunnerState['runnerValue']) => void;
    reset: () => void;
}